/**
 * Truncates `label` with a trailing ellipsis so its rendered width fits in
 * `maxWidth` px. Returns `label` unchanged if it already fits, or `"…"` alone
 * if even the ellipsis overflows. Binary-searches prefix lengths.
 *
 * Caller must set `ctx.font` before calling.
 */
export const truncateToFit = (label: string, ctx: CanvasRenderingContext2D, maxWidth: number): string => {
  if (ctx.measureText(label).width <= maxWidth) return label;

  const ellipsis = '…';
  if (ctx.measureText(ellipsis).width > maxWidth) return ellipsis;

  let lo = 0;
  let hi = label.length;
  let best = 0;
  while (lo <= hi) {
    const mid = (lo + hi) >>> 1;
    const candidate = label.slice(0, mid) + ellipsis;
    if (ctx.measureText(candidate).width <= maxWidth) {
      best = mid;
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }

  return label.slice(0, best) + ellipsis;
};
